export const domain = 'https://yanceyleo.com';
export const mDomain = 'https://m.yanceyleo.com';
export const wwwDomain = 'https://www.yanceyleo.com';

export const api = {
  prod: 'https://api.yanceyleo.com/api',
  dev: '127.0.0.1:3001/api',
};

export const sentryDNS = 'https://2998f0f7a05044969a7859a2596e6977@sentry.io/1468725';

export const aliOSS = '//yancey-assets.oss-cn-beijing.aliyuncs.com';
export const webpSuffix = '?x-oss-process=image/format,webp';
export const thumbSuffix = '?x-oss-process=image/resize,w_120/quality,Q_10';
export const middleThumbSuffix =
  '?x-oss-process=image/resize,w_360/quality,Q_90';

export const miku = `${aliOSS}/miku.gif`;
export const blogBg = `${aliOSS}/static/blog_page_header.jpg`;
export const archiveBg = `${aliOSS}/NZqlumt.jpg`;
export const musicBg = `${aliOSS}/static/music_page_header.jpg`;
export const avatar = `${aliOSS}/static/logo_avatar.jpg`;
export const legalBg = `${aliOSS}/static/legal_page_header.jpg`;
export const cup = `${aliOSS}/drink.hash-d2bcd7.png`;

export const GA = 'UA-114532340-1';

export const ipify = 'https://api.ipify.org/';

export const byNcSa =
  'https://creativecommons.org/licenses/by-nc-sa/4.0/deed.en';

export const livere = 'MTAyMC8zOTU5NC8xNjEyMQ==';

export const svgSprite = {
  telegram: '#telegram',
  github: '#github',
  soundcloud: '#soundcloud',
  paypal: '#paypal',
  rocket1: '#rocket',
  megaphone: '#megaphone',
  more: '#more',
  sandClock: '#sand-clock',
  heart: '#heart',
  rocket2: '#startup',
  instagram: '#instagram',
  fire: '#flame',
  wechat: '#wechat',
  twitter1: '#twitter',
  barcelona: '#barcelona',
  fireworks: '#fireworks',
  eye: '#eye',
  apple: '#apple',
  ubuntu: '#ubuntu',
  new: '#new',
  cv: '#curriculum-vitae',
  tools: '#gear',
  mail: '#mail',
  comments1: '#multimedia',
  code1: '#html-coding',
  openFolder: '#open-folder',
  archive: '#archive-black-box',
  home: '#home',
  share1: '#share-symbol',
  rss: '#rss-symbol',
  apps: '#app-store-apple-symbol',
  blog: '#blogger-letter-logotype',
  comments2: '#blog-comment-speech-bubble-symbol',
  search1: '#musica-searcher',
  photo: '#frame-landscape',
  settings: '#settings',
  camera: '#photo-camera',
  rightArrow: '#right-arrow',
  leftArrow: '#left-arrow',
  link: '#unlink',
  user: '#user',
  share2: '#share',
  like: '#like',
  time: '#time',
  closeFolder: '#folder',
  music: '#music-player',
  leftQuote: '#left-quote',
  rightQuote: '#right-quote',
  search2: '#magnifying-glass',
  history: '#history',
  mortarBoard: '#mortarboard',
  code2: '#code',
  crown: '#placeholder',
  tag: '#price-tag',
  balloons: '#balloons',
  twitter2: '#twitter-1',
  planet: '#twitter-1',
  astronaut: '#astronaut',
  close: '#close',
};

export const socialMedia = {
  github: {
    url: 'https://github.com/YanceyOfficial/',
    icon: '#github',
  },
  twitter: {
    url: 'https://twitter.com/YanceyOfficial/',
    icon: '#twitter',
  },
  instagram: {
    url: 'https://www.instagram.com/yancey_leo/',
    icon: '#instagram',
  },
  soundCloud: {
    url: 'https://soundcloud.com/yancey-leo/',
    icon: '#soundcloud',
  },
  telegram: {
    url: 'https://t.me/YanceyOfficial',
    icon: '#telegram',
  },
  paypal: {
    url: 'https://www.paypal.me/yanceyleo/10usd',
    icon: '#paypal',
  },
  wechat: {
    url: '/',
    icon: '#wechat',
  },
  email: {
    url: 'mailto:yanceyofficial@gmail.com',
    icon: '#mail',
  },
};
